import { Result } from '@coveo/headless';
import { HeadlessSearchResult } from '../adapter/headless-search-result.interface';
import { HeadlesssSearchResultsAdapter } from '../adapter/headless-search-results.adapter';

/**
 * Adapt and format Coveo Results to UI Headless Search Result
 * Used for search results and recommendations.
 * @param results
 * @returns
 */
export function adaptCoveoResults(opts: { results: Result[]; isAuthed: boolean }): HeadlessSearchResult[] {
    const { results, isAuthed } = opts;
    const adapter = new HeadlesssSearchResultsAdapter();
    return results.map((result: Result) => adapter.adapt({ result, isAuthed }));
}
